module.exports = __webpack_public_path__ + "img/9.fbe0d24b.jpg";